<template>
  <v-checkbox
    class="imd-sm-input-chkbox"
    :label="label"
    :value="value" @change="value => $emit('input', value)"
  >
    <slot></slot>
  </v-checkbox>
</template>

<script>
 export default {
  props: ['value', 'label'],
}
</script>
